export const ADD_UPDATE_NOTE_REQUEST = "ADD_UPDATE_NOTE_REQUEST";
export const ADD_UPDATE_NOTE_SUCCESS = "ADD_UPDATE_NOTE_SUCCESS";
export const ADD_UPDATE_NOTE_FAILURE = "ADD_UPDATE_NOTE_FAILURE";
